// extracted by mini-css-extract-plugin
module.exports = {"banner":"Object_banner__VcMyW","bannerTitle":"Object_bannerTitle__5qTHs","bannerSubtitle":"Object_bannerSubtitle__PUiP0"};